let highlightIdCounter = 0;

/**
 * Generates a stable identifier for highlight segments so their map layer IDs
 * remain consistent even if the list order changes.
 */
export function createHighlightId(): string {
  const counter = (highlightIdCounter += 1);
  const timestamp = Date.now().toString(36);
  return `hl-${timestamp}-${counter.toString(36)}`;
}
